import { useEffect } from "react";
import styled, {
  ClientForm,
  TextInput,
  FormActions,
  Button,
  px,
} from "livemap-ui";
import { useForm } from "react-hook-form";
import { useAddToast } from "../contexts/toast";
import { useFocus } from "../hooks/focus";
import { FormProps } from "./FormProps";

export interface NameData {
  firstName: string;
  lastName: string;
}

export interface NameFormProps {
  submitText: string;
  isSending: boolean;
}

export interface NameFormDispatch {
  onSubmit(form: NameData): void;
}

type Props = NameFormDispatch & NameFormProps & FormProps;

export function NameForm({ isSending, onSubmit, submitText, isActive }: Props) {
  const addToast = useAddToast();
  const [focusRef, setInputFocus] = useFocus();
  const { register, handleSubmit, errors } = useForm<NameData>({
    reValidateMode: "onBlur",
  });

  useEffect(() => {
    if (errors.firstName) {
      addToast({
        id: "bad-first-name",
        title: "Invalid name",
        text: errors.firstName.message || "",
        type: "danger",
      });
    }

    if (errors.lastName) {
      addToast({
        id: "bad-last-name",
        title: "Invalid name",
        text: errors.lastName.message || "",
        type: "danger",
      });
    }
  }, [addToast, errors.firstName, errors.lastName]);

  useEffect(() => {
    isActive && setInputFocus();
  }, [isActive, setInputFocus]);

  return (
    <ClientForm onSubmit={handleSubmit(onSubmit)}>
      <Inline>
        <TextInput
          label="First name"
          name="firstName"
          ref={(htmlRef) => {
            focusRef.current = htmlRef;
            register({ required: "Please enter your first name." })(htmlRef);
          }}
        />

        <TextInput
          label="Last name"
          name="lastName"
          ref={register({ required: "Please enter your last name." })}
        />
      </Inline>

      <FormActions>
        <Button disabled={isSending}>{submitText}</Button>
      </FormActions>
    </ClientForm>
  );
}

const Inline = styled.div`
  display: flex;
  flex-direction: row;

  > *:first-child {
    width: ${px(240)};
    padding-right: ${px(6)};
  }
`;
